module.exports = __webpack_public_path__ + "static/media/rm.8eae2fac.png";